import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, Validation, DateTimeUtils } from '@mews/framework';
import { CalendarService } from '@optimus-web/core';
import { OnboardingTextKey } from '../../../../OnboardingTextKey';
import { disableDate } from './utils';

export const createSchema = (calendarService: CalendarService) =>
    z.object({
        goLiveDate: Validation.Date.Iso.superRefine((value, ctx) => {
            const date = DateTimeUtils.dateIsoStringToDate(value);
            const structuredDate = DateTimeUtils.dateToStructuredDate(date);

            if (disableDate(structuredDate, calendarService)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    params: {
                        errorType: CustomErrorType.Other,
                        textKey: OnboardingTextKey.OnboardingAuditGoLiveDateDialogInputError,
                    } satisfies CustomErrorParams,
                });
            }
        }),
    });

export type FormValues = z.infer<ReturnType<typeof createSchema>>;
